import { de, enGB, es, fr, hu, nl, pt, it } from 'date-fns/locale'

export default { de, en: enGB, es, fr, hu, nl, pt, it }
